module.exports = __webpack_public_path__ + "img/img12.dbc335a9.svg";